import * as R from 'ramda';

import { RangeInputValues } from 'src/components/molecules/RangeInput';
import { FilterOption, SelectedFilterOption } from 'src/types';

const sortByAscending = (v1: number, v2: number): number => v1 - v2;

const castValuesToNumber = (option: SelectedFilterOption) => Number(option.filterOptionValue);

const isRangeFilterOption = ({ filterUid }: SelectedFilterOption, rangeFilterUid: string) =>
  filterUid === rangeFilterUid;

export const getRangeInputValues = (
  selectedfilterOptions: SelectedFilterOption[],
  rangeFilterUid: string,
  initialValues: [number, number],
  filterOptions: FilterOption[],
): RangeInputValues => {
  const selectedRangeFilterOptions = selectedfilterOptions.filter((option) =>
    isRangeFilterOption(option, rangeFilterUid),
  );

  if (!selectedRangeFilterOptions.length) {
    return initialValues;
  }

  const keepBelowMax = (maxValue?: number) => (value: number) => Math.min(value, maxValue ?? value);
  const keepAboveMin = (minValue?: number) => (value: number) => Math.max(value, minValue ?? value);

  const values = selectedRangeFilterOptions
    .map(
      R.compose(
        keepBelowMax(filterOptions[1]?.maxValue),
        keepAboveMin(filterOptions[0]?.minValue),
        castValuesToNumber,
      ),
    )
    .sort(sortByAscending);

  // If only one of the range input values is selected, use the other initial value for the other value
  if (values.length === 1) {
    const selectedRangeFilterOption = filterOptions.find(
      ({ uid }) => uid === selectedRangeFilterOptions[0].filterOptionUid,
    );

    return Number.isInteger(selectedRangeFilterOption?.minValue)
      ? (values.concat([initialValues[1]]) as RangeInputValues)
      : ([initialValues[0]].concat(values) as RangeInputValues);
  }

  return values as RangeInputValues;
};
